export default "__VITE_ASSET__3jZxFM7E__"